import React, { useEffect } from 'react';
import { extrasPorBono } from '../../../shared/helpers/api/apiCall';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { CleaningServicesOutlined } from '@mui/icons-material';

export const DatosParaBono = ({ tipo, selectedDriver, fechaBono, user, ruta, setRuta }) => {
    if (fechaBono === '' || tipo === '' || user === '') {
        return null;
    }

    useEffect(() => {
        const params = `date=${fechaBono}&driver=${selectedDriver.id}`;

        const fetchRouteData = async () => {
            try {
                const response = await extrasPorBono('conductor-fecha', user, params);
                const formattedData = response.data;
                setRuta(formattedData);
            } catch (error) {
                // console.error('error: ', error);
            }
        };

        fetchRouteData();
    }, [fechaBono]);

    return (
        <>
            {ruta && ruta.ruta ? (
                <TextField
                    fullWidth
                    label="Ruta"
                    type='text'
                    name='ruta'
                    variant="outlined"
                    margin="normal"
                    value={ruta.ruta || ''}
                    disabled
                />
            ) : (
                <TextField
                    fullWidth
                    label="Error"
                    type='text'
                    name='ruta'
                    variant="outlined"
                    margin="normal"
                    value="Sin Ruta ese día"
                    error
                    helperText="Seleccione una fecha con ruta válida"
                    disabled
                />
            )}
        </>
    );
};